// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__T0psY","container":"Footer_container__R7sXj","footerSignature":"Footer_footerSignature__wnClW","slidein":"Footer_slidein__TlnNO"};